var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperienceDesignIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 19C25.7761 19 26 18.7761 26 18.5C26 18.2239 25.7761 18 25.5 18C25.2239 18 25 18.2239 25 18.5C25 18.7761 25.2239 19 25.5 19Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 23C29.7761 23 30 22.7761 30 22.5C30 22.2239 29.7761 22 29.5 22C29.2239 22 29 22.2239 29 22.5C29 22.7761 29.2239 23 29.5 23Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20C20.7761 20 21 19.7761 21 19.5C21 19.2239 20.7761 19 20.5 19C20.2239 19 20 19.2239 20 19.5C20 19.7761 20.2239 20 20.5 20Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 25C18.7761 25 19 24.7761 19 24.5C19 24.2239 18.7761 24 18.5 24C18.2239 24 18 24.2239 18 24.5C18 24.7761 18.2239 25 18.5 25Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14C18.5 14 14 18.5 14 24C14 29.5 18.5 34 24 34C24.926 34 25.648 33.254 25.648 32.312C25.648 31.875 25.468 31.477 25.211 31.187C24.921 30.898 24.773 30.535 24.773 30.062C24.7692 29.8419 24.8098 29.6233 24.8922 29.4192C24.9747 29.2151 25.0975 29.0298 25.2531 28.8741C25.4088 28.7185 25.5941 28.5957 25.7982 28.5132C26.0023 28.4308 26.2209 28.3902 26.441 28.394H28.437C31.488 28.394 33.992 25.891 33.992 22.84C33.965 18.012 29.461 14 24 14Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceDesignIcon);
export default __webpack_public_path__ + "static/media/ExperienceDesignIcon.ba4d7f5e3753ca0f8e775578f8a9fdc0.svg";
export { ForwardRef as ReactComponent };